



























import Vue from 'vue'
import ProductTag from '@/product/components/ProductTag.vue'
import {
  ProductSearchTag,
  ProductState
} from '@/product/types'

const MAX_DEFAULT_TAGS = 6

export default Vue.extend({
  components: {
    ProductTag
  },
  data(): {
    isExpanded: boolean
  } {
    return {
      isExpanded: false
    }
  },
  computed: {
    filteredTags(): readonly ProductSearchTag[] {
      return this.searchTags.slice(0, this.visibleNumber)
    },
    searchTags(): readonly ProductSearchTag[] {
      return (this.$store.state as ProductState).productDetail.searchTags || []
    },
    visibleNumber(): number {
      const tagLength = this.searchTags.length
      return tagLength <= MAX_DEFAULT_TAGS ? tagLength
      : this.isExpanded ? tagLength : MAX_DEFAULT_TAGS
    },
    expandVisible(): boolean {
      return this.searchTags.length > MAX_DEFAULT_TAGS
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  }
})
